import { BookOpen, Monitor } from "lucide-react";
import { AssessmentChoice } from "src/components/assessment/AssessmentChoice";

interface SubjectSelectorProps {
  value: "math" | "cs" | null;
  onChange: (subject: "math" | "cs") => void;
}

const subjects = [
  {
    id: "math" as const,
    label: "Mathematics",
    description: "Questions follow your grade and curriculum board.",
    icon: BookOpen,
  },
  {
    id: "cs" as const,
    label: "Computer Science",
    description: "Python or JavaScript, one track.",
    icon: Monitor,
  },
];

export function SubjectSelector({ value, onChange }: SubjectSelectorProps) {
  return (
    <div className="flex flex-col gap-3" role="group" aria-label="Subject">
      {subjects.map((subject) => (
        <AssessmentChoice
          key={subject.id}
          label={subject.label}
          description={subject.description}
          icon={subject.icon}
          selected={value === subject.id}
          onClick={() => onChange(subject.id)}
        />
      ))}
    </div>
  );
}

export default SubjectSelector;
